module.exports = __webpack_public_path__ + "img/handbook-cta_en.5fee7f9.jpg";